module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n            Adicione arquivos com os resultados do projeto na aba ARQUIVOS.\n          ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Descrição dos resultados do projeto de pesquisa*",
      "counter": "5000",
      "rows": 3,
      "auto-grow": true,
      "rules": _vm.obrigatorio.concat( _vm.max5000caracteres),
      "hint": "Deve ser inserida a referência das produções científica(s), tecnológica(s) e artística(s) e a formação de recursos humanos oriundas do projeto de pesquisa."
    },
    model: {
      value: (_vm.projetoPesquisa.resultadosObtidos),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "resultadosObtidos", $$v)
      },
      expression: "projetoPesquisa.resultadosObtidos"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Declaro, para devidos fins de direito, que as informações prestadas são verdadeiras e autênticas. Fico ciente de que a falsidade dessa declaração configura crime previsto no Código Penal Brasileiro, passível de penalidade.*",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.projetoPesquisa.declaracaoResultadosObtidos),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "declaracaoResultadosObtidos", $$v)
      },
      expression: "projetoPesquisa.declaracaoResultadosObtidos"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59ffe970","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/editar-resultados-obtidos.vue
// module id = 925
// module chunks = 0